export default "__VITE_ASSET__DIiEWkkr__"